export enum LocalStorageKeys {
	USER = "user",
	TOKEN = "token",
	REFRESH_TOKEN = "refresh_token",
	DASHBOARD_PREFERENCES = "dashboard_preferences",
}
